import React, { useEffect, useState } from 'react';
import { Switch } from 'antd';
import axios from 'axios';
import { toast } from 'react-toastify';
import config from '../../config';
import { playNotifSound } from '../../utils/notifSound';
import './notificationPrefs.css';

const DOMAIN = config.REACT_APP_SERVER_DOMAIN;

// Le niveau est le réglage PRINCIPAL ; les familles deviennent un affinage.
// Ce que chaque niveau laisse passer est décidé côté serveur
// (notification.service.js) — ici on ne fait que le libeller.
const NIVEAUX = [
  { v: 1, label: 'Tout', hint: 'Alertes importantes + activité courante' },
  { v: 2, label: 'L’essentiel', hint: 'Alertes importantes + ce qui touche à l’argent' },
  { v: 3, label: 'Critique seulement', hint: 'Uniquement ce qui demande une réaction' },
];

const FAMILLES = [
  { key: 'fam_commandes', label: 'Commandes', hint: 'Nouvelles commandes, corrections' },
  { key: 'fam_livraisons', label: 'Livraisons', hint: 'Confirmée, prise en charge, en cours, incident' },
  { key: 'fam_echanges_retours', label: 'Échanges et retours', hint: 'Retours clients, retours après échange' },
  { key: 'fam_remboursements', label: 'Remboursements', hint: 'Remboursements clients' },
];

// Paramètres > Notifications (mandat mobile §4) : interrupteur général + un
// interrupteur par catégorie, PAR UTILISATEUR (GET/PUT /api/notifications/
// preferences, identité issue du jeton). Enregistrement immédiat à chaque
// bascule, avec retour arrière si l'API refuse.
const NotificationPrefs = () => {
  const [prefs, setPrefs] = useState(null);

  useEffect(() => {
    let ok = true;
    axios.get(`${DOMAIN}/api/notifications/preferences`)
      .then(({ data }) => { if (ok) setPrefs(data); })
      .catch(() => { if (ok) setPrefs(null); });
    return () => { ok = false; };
  }, []);

  const enregistrer = async (apres) => {
    const avant = prefs;
    setPrefs(apres);
    try {
      await axios.put(`${DOMAIN}/api/notifications/preferences`, apres);
    } catch (e) {
      setPrefs(avant);
      toast.error('Impossible d’enregistrer la préférence.');
    }
  };

  const basculer = (key, value) => enregistrer({ ...prefs, [key]: value ? 1 : 0 });

  if (!prefs) return null;
  const general = Number(prefs.enabled) === 1;
  const niveau = Number(prefs.niveau_min) || 1;

  return (
    <section className="nprefs">
      <h2 className="nprefs-titre">Notifications</h2>
      <div className="nprefs-ligne nprefs-ligne--general">
        <div>
          <b>Recevoir des notifications</b>
          <small>Interrupteur général — coupe tout en une bascule</small>
        </div>
        <Switch checked={general} onChange={(v) => basculer('enabled', v)} />
      </div>

      <div className={`nprefs-niveaux ${general ? '' : 'nprefs-ligne--off'}`}>
        <div className="nprefs-niveaux-entete">
          <b>Ce que je veux recevoir</b>
          <small>Seules les alertes importantes sonnent. Le reste s’accumule en silence.</small>
        </div>
        {NIVEAUX.map((n) => (
          <button
            type="button"
            key={n.v}
            className={`nprefs-niveau ${niveau === n.v ? 'is-actif' : ''}`}
            disabled={!general}
            onClick={() => enregistrer({ ...prefs, niveau_min: n.v })}
          >
            <span className="nprefs-niveau-label">{n.label}</span>
            <span className="nprefs-niveau-hint">{n.hint}</span>
          </button>
        ))}
        <button
          type="button"
          className="nprefs-essai"
          disabled={!general}
          onClick={() => playNotifSound(1)}
        >
          Écouter le son des alertes
        </button>
      </div>

      <div className="nprefs-affiner">Affiner par catégorie</div>
      {FAMILLES.map((f) => (
        <div className={`nprefs-ligne ${general ? '' : 'nprefs-ligne--off'}`} key={f.key}>
          <div>
            <b>{f.label}</b>
            <small>{f.hint}</small>
          </div>
          <Switch
            checked={Number(prefs[f.key]) === 1}
            disabled={!general}
            onChange={(v) => basculer(f.key, v)}
          />
        </div>
      ))}
    </section>
  );
};

export default NotificationPrefs;
